import { RequireEntityGuard } from "@core/presentacion/component/routing/require-entity/require-entity.guard";
import { RequireRoleGuard } from "@core/presentacion/component/routing/require-role/require-role.guard";
import { UserRoleEnum } from "@user/domain/models/user-role.model";
import { lazy } from "react";
import { Route } from "react-router-dom";

const ServiceListPage = lazy(async () =>
    import(
        /* webpackChunkName: "ServiceListPage" */ "@catalogue/presentation/pages/service/service.page"
    ).then((module) => ({ default: module.ServiceListPage })),
);

const CreateServicePage = lazy(async () =>
    import(
        /* webpackChunkName: "CreateServicePage" */ "@catalogue/presentation/pages/service/create/create-service.page"
    ).then((module) => ({ default: module.CreateServicePage })),
);

const DerivationListPage = lazy(async () =>
    import(
        /* webpackChunkName: "DerivationListPage" */ "@catalogue/presentation/pages/derivation/derivation.page"
    ).then((module) => ({ default: module.DerivationListPage })),
);

const DerivationCreatePage = lazy(async () =>
    import(
        /* webpackChunkName: "DerivationCreatePage" */ "@catalogue/presentation/pages/derivation/create/derivation.page"
    ).then((module) => ({ default: module.DerivationCreatePage })),
);

const DerivationEditPage = lazy(async () =>
    import(
        /* webpackChunkName: "DerivationEditPage" */ "@catalogue/presentation/pages/derivation/edit/derivation.page"
    ).then((module) => ({ default: module.DerivationEditPage })),
);

export class CataloguePaths {
    static readonly Root = "catalogue";
    static readonly Services = "services";
    static readonly Create = "create";
    static readonly Derivations = "derivations";
    static readonly EditParam = ":derivationId";
    static readonly Edit = `edit/${CataloguePaths.EditParam}`;
}

export class CatalogueRoutes {
    static LIST = `/${CataloguePaths.Root}`;

    static SERVICES = `/${CataloguePaths.Root}/${CataloguePaths.Services}`;
    static CREATE_SERVICE = `/${CataloguePaths.Root}/${CataloguePaths.Services}/${CataloguePaths.Create}`;
    static DETAIL_SERVICE = (id: number): string =>
        `/${CataloguePaths.Root}/${CataloguePaths.Services}/detail/${id}`;

    static DERIVATIONS = `/${CataloguePaths.Root}/${CataloguePaths.Derivations}`;
    // Añadir este método en CatalogueRoutes
    static EDIT_DERIVATION = (derivationId: number): string =>
        `/${CataloguePaths.Root}/${CataloguePaths.Derivations}/${CataloguePaths.Edit.replace(
            CataloguePaths.EditParam,
            derivationId.toString(),
        )}`;
    static CREATE_DERIVATION = `/${CataloguePaths.Root}/${CataloguePaths.Derivations}/${CataloguePaths.Create}`;
}

export const catalogueRoutes = (
    <Route path={CataloguePaths.Root}>
        <Route
            element={
                <RequireRoleGuard
                    rolesIn={[
                        UserRoleEnum.SuperAdmin,
                        UserRoleEnum.Admin,
                        UserRoleEnum.EntityAdmin,
                    ]}
                >
                    <ServiceListPage />
                </RequireRoleGuard>
            }
            path={CataloguePaths.Services}
        />
        <Route
            element={
                <RequireRoleGuard
                    rolesIn={[
                        UserRoleEnum.SuperAdmin,
                        UserRoleEnum.Admin,
                        UserRoleEnum.EntityAdmin,
                    ]}
                >
                    <RequireEntityGuard redirectTo={CatalogueRoutes.SERVICES}>
                        <CreateServicePage />
                    </RequireEntityGuard>
                </RequireRoleGuard>
            }
            path={`${CataloguePaths.Services}/${CataloguePaths.Create}`}
        />
        <Route
            element={
                <RequireRoleGuard
                    rolesIn={[
                        UserRoleEnum.SuperAdmin,
                        UserRoleEnum.Admin,
                        UserRoleEnum.EntityAdmin,
                    ]}
                >
                    <DerivationListPage />
                </RequireRoleGuard>
            }
            path={CataloguePaths.Derivations}
        />
        <Route
            element={
                <RequireRoleGuard
                    rolesIn={[
                        UserRoleEnum.SuperAdmin,
                        UserRoleEnum.Admin,
                        UserRoleEnum.EntityAdmin,
                    ]}
                >
                    <DerivationCreatePage />
                </RequireRoleGuard>
            }
            path={`${CataloguePaths.Derivations}/${CataloguePaths.Create}`}
        />
        <Route
            element={
                <RequireRoleGuard
                    rolesIn={[
                        UserRoleEnum.SuperAdmin,
                        UserRoleEnum.Admin,
                        UserRoleEnum.EntityAdmin,
                    ]}
                >
                    <DerivationEditPage />
                </RequireRoleGuard>
            }
            path={`${CataloguePaths.Derivations}/${CataloguePaths.Edit}`}
        />
    </Route>
);
